import React, { createContext, useCallback, useContext, useState } from 'react';
import { fetchConToken, fetchSinToken } from '../api/fetch';
import { RedContext } from '../context/connection/ContextRed';
import { UserContext } from '../context/user/ContextUser';
import { redtypes } from '../types/redTypes';

export const AuthContext = createContext();

const initialState = {
    uid: null,
    checking: true,
    logged: false,
    name: null,
    user: null,
    movil: null,
    email: null,
    foto: null,
    roll: null,
    accesos: null,
    conected: null,
    color: '#82818d',
    apitk: null,
    alert: false,
};

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState(initialState);
    const { dispatchRed } = useContext(RedContext);
    const { dispatchUs } = useContext(UserContext);
    const login = async (user, password) => {
        const resp = await fetchSinToken('auth/login', { user, password }, 'POST');
        //
        if (resp.ok) {
            localStorage.setItem('token', resp.token);
            localStorage.setItem('stado', 'ACTIVO');
            const { agente } = resp;
            localStorage.setItem('allows', agente.permisos);
            setAuth({
                uid: agente.id_agent,
                checking: false,
                logged: true,
                name: agente.name,
                user: agente.user,
                email: agente.email,
                roll: agente.rol,
                foto: agente.foto,
                movil: agente.movil,
                accesos: JSON.parse(agente.permisos),
                color: agente.color,
                apitk: agente.apitk,
                alert: agente.alert,
            });
        }

        return resp.ok;
    };

    const verificaToken = useCallback(async () => {
        const token = localStorage.getItem('token');

        // Si token no existe
        if (!token) {
            setAuth({
                uid: null,
                checking: false,
                logged: false,
                name: null,
                user: null,
                email: null,
                movil: null,
                foto: null,
                roll: null,
                accesos: null,
                conected: null,
                color: '#82818d',
                apitk: null,
            });

            return false;
        }

        const resp = await fetchConToken('auth/renew');

        if (resp.ok) {
            localStorage.setItem('token', resp.token);
            const { agente } = resp;

            localStorage.setItem('allows', agente.permisos);

            setAuth({
                uid: agente.id_agent,
                checking: false,
                logged: true,
                name: agente.name,
                user: agente.user,
                email: agente.email,
                roll: agente.rol,
                movil: agente.movil,

                foto: agente.foto,
                accesos: JSON.parse(agente.permisos),

                color: agente.color,
                apitk: agente.apitk,
                alert: agente.alert,
            });

            return true;
        } else {
            setAuth({
                uid: null,
                checking: false,
                logged: false,
                name: null,
                user: null,
                email: null,
                movil: null,
                foto: null,
                roll: null,
                accesos: null,
                conected: null,
                color: '#82818d',
                apitk: null,
            });

            return false;
        }
    }, []);

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('allows');
        dispatchRed({
            type: redtypes.cerrarSesion,
        });
        dispatchUs({
            type: redtypes.cerrarSesion,
        });
        setAuth({
            uid: null,
            checking: false,
            logged: false,
            name: null,
            user: null,
            movil: null,
            email: null,
            foto: null,
            roll: null,
            accesos: null,
            conected: null,
            color: '#82818d',
            apitk: null,
        });
    };

    return (
        <AuthContext.Provider
            value={{
                auth,
                login,
                verificaToken,
                logout,
            }}>
            {children}
        </AuthContext.Provider>
    );
};
